import { faFileDoc, faFilePdf } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { downloadSingleMailerUrl } from 'bundles/connect/helpers/prospect_api';
import React from 'react';
import { Button, Modal } from 'react-bootstrap-5';

type DownloadModalProps = {
  callListId: number;
  templateId: number;
  callListItemId: number;
  show: boolean;
  onHide: () => void;
};

export default function SingleDownloadModal(
  { callListId, templateId, callListItemId, show, onHide }: DownloadModalProps
) {

  const handleDownload = (format: 'docx' | 'pdf') => {
    const url = downloadSingleMailerUrl(callListId, templateId, callListItemId, format);

    window.open(url, '_blank');
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Download Mailer</Modal.Title>
      </Modal.Header>
      <Modal.Body className="d-flex flex-column gap-2">
        <div>
          Please select your download format from the options below.
        </div>
        <div className="d-flex gap-2">
          <Button
            className="flex-grow-1"
            variant="outline-secondary"
            onClick={() => handleDownload('docx')}
          >
            <FontAwesomeIcon icon={faFileDoc} />
            Download as Docx
          </Button>
          <Button
            className="flex-grow-1"
            variant="outline-secondary"
            onClick={() => handleDownload('pdf')}
          >
            <FontAwesomeIcon icon={faFilePdf} />
            Download as PDF
          </Button>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="text-primary" onClick={onHide}>Cancel</Button>
      </Modal.Footer>
    </Modal>
  );
}
